import React from 'react'
import { ICONS, ICON_SCALE } from '../globals'
import styled from 'styled-components'

const Container = styled.g``
const Circle = styled.circle`
  stroke: #fff;
  stroke-width: 1.5;
`

export const IconCircle = ({
  x,
  y,
  rad,
  color,
  icon,
  iconColor = '#fff', //'rgba(32,35,70,.3)',
  iconScale = ICON_SCALE
}: {
  x: number
  y: number
  rad: number
  color: string
  icon?: indicatorTypes
  iconColor?: string
  iconScale?: number
}) => {
  return (
    <Container>
      <Circle cx={x} cy={y} r={rad} fill={color} className={icon} />
      {icon && (
        <path
          d={ICONS[icon]}
          transform={`translate(${x},${y})scale(${iconScale})`}
          fill={iconColor}
        />
      )}
    </Container>
  )
}
